import { render, staticRenderFns } from "./ResetAccountPasswordView.vue?vue&type=template&id=185e5bb7&scoped=true&"
import script from "./ResetAccountPasswordView.vue?vue&type=script&lang=ts&"
export * from "./ResetAccountPasswordView.vue?vue&type=script&lang=ts&"
import style0 from "./ResetAccountPasswordView.vue?vue&type=style&index=0&id=185e5bb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185e5bb7",
  null
  
)

export default component.exports